import {get as _get, isEmpty as _isEmpty} from 'lodash';
import {withRouter} from 'react-router';

import DefaultForm from '@appComponents/DefaultForm';
import {renderPageTitle} from '@utils/helpers';
import {getLink} from '@appComponents/Link';

export class EncodingJobProfileForm extends DefaultForm {
    componentDidMount() {
        this.setUpdateSuccessCallback(() => {
            this.props.history.push(this.createLinkToIndexPage());
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        let encodingJobProfileName = null;
        const clients = _get(this.props, 'GraphQLEntityData.encodingJobProfile.clients', []);

        if (!this.state.dataLoaded && !_isEmpty(clients)) {
            this.setField('clients', {
                defaultValue: clients.map((client) => client.id),
            });

            this.setState(() => ({dataLoaded: true}));
        }

        if (null !== this.props.formParams.id) {
            if (undefined !== this.props.GraphQLEntityData.encodingJobProfile) {
                encodingJobProfileName = this.props.GraphQLEntityData.encodingJobProfile.name;
            }
        }

        this.props.formParams.setPageTitle(
            renderPageTitle({
                id: this.props.formParams.id,
                name: encodingJobProfileName,
                entity: this.props.Model.entityLabel,
            })
        );
    }

    prepareDataForSubmit = (data) => ({
        ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
        ...data,
        name: _get(this.props, 'GraphQLEntityData.encodingJobProfile.name', null),
        clients: data?.clients ? data.clients.map(Number) : [],
    });

    createLinkToIndexPage = () => (
        getLink('encodingJobProfile.index')
    );

    renderErrors(errorData) {
        super.renderErrors(errorData, this.props.Model.label, this.createLinkToIndexPage());
    }

    renderSaveButton = () => super.renderSaveButton({content: 'Save'});

    renderDeleteButton = () => null;

    renderCancelButton = () => null;
}

export default withRouter(EncodingJobProfileForm);
